import { getProductSelectionTypesOptions } from '~/ocab-services/measure/utils';
import { ProductRadios } from '~/ocab-services/measure/components/product-radios';
import { RoomOrSpaceTooltip } from '~/ocab-services/measure/components/room-or-space-tooltip';

export const config = {
  ProductsForm: {
    productTypeLabel: 'What product type would you like us to measure for?',
    productTypeLabelForDefaultOption: 'Select product type',
    quantityLabel: 'How many windows is this for?',
    productInformationLabel: 'Tell us more about your fabric or product choice',
    productInformationInstruction: 'Please provide us with the names of the products you have selected, and the approximate window sizes, as well as any special requirements e.g blocking out sunlight.',
    productInformationValidationMessage: 'Please give us details about your window(s)',
    getProductSelectionTypesConfig: products => ({
      component: ProductRadios,
      label: 'Type of window',
      labelHelperElement: (<RoomOrSpaceTooltip usedFor={'curtains'}/>),
      required: true,
      validationMessageKeys: {
        required: 'Please select type of window',
      },
      options: getProductSelectionTypesOptions(products),
    }),
  },
};
